module.exports = __webpack_public_path__ + "img/vi.a96d982f.png";